import { Box, Text } from "native-base";
import { Title } from "../../../component/Title";

const Graduation = () => {
  return (
    <Box>
      <Title label="Formação Acadêmica" />

      <ul>
        <li>
          <Text>
            Graduação em Sistema de Informações – Faculdade Projeção -
            (Concluído - 2013)
          </Text>
        </li>
      </ul>
    </Box>
  );
};

export default Graduation;
